module.exports = __webpack_public_path__ + "static/media/30.2565d4eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/30.png
// module id = 398
// module chunks = 0